import { render, staticRenderFns } from "./TopTable.vue?vue&type=template&id=64753156"
import script from "./TopTable.vue?vue&type=script&lang=js"
export * from "./TopTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports